<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="TemplatePreview"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <ItpButton
      variant="default"
      icon="fa-sync-alt"
      :text="'Reload'|gettext"
      :spinning="actions.reload.isRunning || isPDFLoading"
      class="mx-3"
      @click.prevent.stop="evh_8564662037462133_clickPreventStop($event, {})"
    >
    </ItpButton>
    <DIV
      v-if="!file"
    >
      Loading...
    </DIV>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    class="h-100"
    v-if="loaded"
  >
    <ItpPdfViewer
      :file="file"
      class="h-100"
      v-if="file"
    >
    </ItpPdfViewer>
    <DIV
      class="h-100 d-flex"
      v-if="!sampleData"
    >
      <b-alert
        show
        variant="primary"
        class="m-auto"
      >
        {{ 'Generate HTML previews using the data loaded/entered at the Data tab.'|pgettext('Templates') }}
      </b-alert>
    </DIV>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Close'|pgettext('Templates')"
      variant="default"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class TemplatePreview extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  beginRenderTemplate(...args: any[]) {
    const item = this.item;

    this.isPDFLoading = true;

    $app.connections
      .request('render_template_test_html', {
        content: {
          ...this.item.getData(),
          data: JSON.parse(this.sampleData)
        },
        responseType: 'arraybuffer'
      })
      .then(response => {
        console.log(response)
        console.log(response.data)

        this.setData('file', new File([response.data], 'result.pdf', { type: response.headers['content-type'] }))
      })
      .finally(() => this.isPDFLoading = false)
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    required: true,
    type: String,
  })
  sampleData!: string;

  @Watch('sampleData')
  onSample_data(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("sampleData")
  }

  @Prop({
    type: String,
    default: "full-screen",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  isPDFLoading!: any;
  previewData!: any;

  async $$load_previewData() {
    return this.beginRenderTemplate()
  }

  file!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['isPDFLoading', 'previewData', 'file', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        isPDFLoading: true,
        previewData: null,
        file: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "full-screen",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("TemplatePreview", "Preview"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5648_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5648, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5648: actions.CloseModalAction;
    evh_7315092382398562_close_5647: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_5650: actions.CloseComponentAction;
    evh_2248226175642056_close_5649: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_5652: actions.ReloadComponentDataAction;
    evh_8564662037462133_clickPreventStop_5651: actions.EventHandlerImpl;
    evh_8564662037462133_clickPreventStop: actions.EventHandlerGroup;
    act_1548630417156826_closeModal_5654: actions.CloseModalAction;
    evh_1548630417156826_clickPreventStop_5653: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5648 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5648_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5647 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5648,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5647],
      }
    );
    const act_2248226175642056_closeComponent_5650 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_5649 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_5650,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_5649],
      }
    );
    const act_8564662037462133_reloadComponentData_5652 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8564662037462133_clickPreventStop_5651 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_5652,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8564662037462133_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_clickPreventStop_5651],
      }
    );
    const act_1548630417156826_closeModal_5654 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_1548630417156826_clickPreventStop_5653 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeModal_5654,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_5653],
      }
    );
    return {
      act_7315092382398562_closeModal_5648,
      evh_7315092382398562_close_5647,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_5650,
      evh_2248226175642056_close_5649,
      evh_2248226175642056_close,
      act_8564662037462133_reloadComponentData_5652,
      evh_8564662037462133_clickPreventStop_5651,
      evh_8564662037462133_clickPreventStop,
      act_1548630417156826_closeModal_5654,
      evh_1548630417156826_clickPreventStop_5653,
      evh_1548630417156826_clickPreventStop,
      reload: act_8564662037462133_reloadComponentData_5652,
    }
  }
}

Vue.component("TemplatePreview", TemplatePreview);

</script>